import {iconNewBuscapeIcon, iconNewEbitIcon, iconNewGoogleSafeSiteIcon, iconNewRAIcon} from "../../../../assets";
import {h} from "preact";
import {useAppContext} from "../../../../contexts";

const Recognitions = () => {
    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <div
            className={`bg-white border-y border-[#E3E3E4] font-museo container-fluid flex flex-col text-black ${highContrast ? "grayBackground" : ""}`}>
            <div className=" w-full xmd:sabin-container flex flex-col xmd:justify-between">
                <div className={"flex flex-row justify-between gap-4 flex-wrap my-8 px-0 xmd:px-28 items-center"}>
                    <img
                        src={iconNewBuscapeIcon}
                        alt="Recognition badge"
                        className={"shrink-0 dark:grayscale"}
                        style={{
                            maxWidth: "173px"
                        }}
                    />
                    <img
                        src={iconNewGoogleSafeSiteIcon}
                        alt="Recognition badge"
                        className={"shrink-0 dark:grayscale"}
                    />
                    <img
                        src={iconNewEbitIcon}
                        alt="Recognition badge"
                        className={"shrink-0 dark:grayscale"}
                    />
                    <img
                        src={iconNewRAIcon}
                        alt="Recognition badge"
                        className={"shrink-0 dark:grayscale"}
                    />
                </div>
            </div>
        </div>
    )
}

export default Recognitions;
